module.exports = __webpack_public_path__ + "img/shipo-icon-weather-raining.f7da92e6.svg";